module.exports = __webpack_public_path__ + "img/trial1-1.31435759.png";